import { render } from "./ActionsComponent.vue?vue&type=template&id=9af78126&scoped=true"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"

import "./ActionsComponent.vue?vue&type=style&index=0&id=9af78126&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af78126"]])

export default __exports__